module.exports = __webpack_public_path__ + "static/media/lote-approve-hero.623e22c2.jpg";